module.exports = __webpack_public_path__ + "static/media/chia-work-1.b4687549.jpg";